<template>
	<div>
		<van-nav-bar title="详情" left-text="返回" left-arrow @click-left="onClickLeft" fixed />
		<div class="psiDetailCont">
			<div style="display: flex;">
				<van-field
				  v-model="value"
				  center
				  clearable
				  label="条码"
				  placeholder="请输入条码"
				  ref="barcodeInput"
				>
				  <template #button>
					<van-button size="small" type="info" @click="confirm">确定</van-button>
				  </template>
				</van-field>
			</div>
			<van-tabs @click="switchTab" v-model="active">
				<van-tab :title="tab.name" :key="tab.id" v-for="tab in tabList">
					<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
						<van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
							<div v-for="form in list" class="card" :key="form.uuid">
								<template v-if="active != 2">
									<table class="layout">
										<tr>
											<td>{{form.orderNumber}}</td>
											<td>{{form.produceOrderNo}}</td>
											<td>{{form.produceCustomerId}}</td>
										</tr>
                                        <tr v-for="obj in form.details" :key="obj.field1">
                                            <td>{{obj.field1}}</td>
                                            <td>{{obj.field2}}</td>
                                            <td>{{obj.field3}}</td>
                                        </tr>
										<tr>
											<td>{{form.barcode}}</td>
											<td>{{form.positionname}}</td>
											<td>{{form.outputTime}}</td>
										</tr>
									</table>
								</template>
								<template v-else>
									<table class="layout">
										<tr>
											<td>{{form.orderNumber}}</td>
										</tr>
                                        <tr v-for="obj in form.details" :key="obj.field1">
                                            <td>{{obj.field1}}</td>
                                            <td>{{obj.field2}}</td>
                                            <td>{{obj.field3}}</td>
                                        </tr>
										<tr>
											<td colspan="2" class="content">
												<p><span>已扫：</span><span>{{form.outputCount}}</span><span class="spanBox">应扫：</span><span>{{form.actualOut}}</span></p>
											</td>
										</tr>
									</table>
								</template>
							</div>
						</van-list>
					</van-pull-refresh>
				</van-tab>
			</van-tabs>
		</div>
		<div class="recordBox">
			<table style="background-color: #1989fa;width: 100%;margin-bottom: 3px;">
				<tr style="height:40px;">
					<td style="width: 20%;color:white;text-align: center;">已扫码:</td>
					<td style="width: 40%;color:white;">{{outNumber}}</td>
					<td style="width: 20%;color:white;">待扫码:</td>
					<td style="width: 20%;color:white;">{{toOutNumber}}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
	import {
		NavBar,
		Button,
		Toast,
		Icon,
		Dialog,
		Tab,
		Tabs,Field,
		List,
		PullRefresh,
		Popup,
		Search
	} from 'vant';
	import moment from "moment";
	import barcodeService from "../../service/barcodeService";
    import {formatDictionary} from "../../utils/dictionary";
	export default {
		data() {
			return {
				active: 0,
				list: [],
				loading: false,
				finished: false,
				pageIndex: 0,
				tab: null,
				uuid:"",
				scanningOutputId:"0",
				value:"",
				tabList: [
					{id:1,name:'待扫码'},
					{id:2,name:'已扫码'},
					{id:3,name:'明细'},
				],
				refreshing: false,
				outNumber: 0,
				toOutNumber: 0,
				fields:[],
				dictNames: ""
			};
		},
		components: {
			[NavBar.name]: NavBar,
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Field.name]: Field,
			[Dialog.name]: Dialog,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
		},
		mounted() {
			this.$refs.barcodeInput.focus();
			this.tab = this.tabList[0];
			let that = this;
			document.onkeydown = function(event) {
			    if (event.keyCode == 13) {
			    	if(that.value.length === 0){
						this.$refs.barcodeInput.focus();
			    		return;
					}
					that.confirm();
			  }
			}
		},
        created: async function () {
            this.uuid = this.$route.query.uuid;
            this.scanningOutputId = this.$route.query.scanningOutputId;
            this.getScanningOutput();
        },
		methods: {
			onClickLeft() {
			    this.$router.go(-1);
			},
			async getScanningOutput(){
				let resp = await barcodeService.getScanningOutput(this.scanningOutputId);
				if (resp.data.Status === "1"){
					let data = resp.data.Data;
					this.outNumber = data.outNumber;
					this.toOutNumber = data.toOutNumber;
				}
			},
			async onLoad() {
				this.pageIndex++;
                if(this.dictNames == ""){
                    let resp = await barcodeService.getBarcodeFieldList();
                    if (resp.data.Status == "1") {
                        this.fields = resp.data.Data;
                        if(this.fields.length > 0){
                            let tempDict = "position.rad_position";
                            this.fields.forEach(item => {
                                if(item.type == "6"){
                                    tempDict += ",";
                                    tempDict += item.name;
                                    tempDict += ".";
                                    tempDict += item.dictName;
                                }
                            });
                            this.dictNames = tempDict;
                        }else{
                            this.dictNames = "radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method,position.rad_position";
                        }
                    }
                }
				let resp;
				if (this.tab.id === 1) {
					resp = await barcodeService.getReadyOutBarcode(this.pageIndex,this.uuid, this.dictNames);
				} else if (this.tab.id === 2) {
					resp = await barcodeService.getAlreadyOutBarcode(this.pageIndex,this.uuid, this.dictNames);
				} else {
					resp = await barcodeService.getOutOfStockDetail(this.uuid, this.dictNames);
				}
				if (resp.data.Status === "1") {
					resp.data.Data.data.forEach(item => {
						item.createTime = moment(item.createTime).format('YYYY-MM-DD');
						item.inputTime = moment(item.inputTime).format('YYYY-MM-DD');
						item.outputTime = moment(item.outputTime).format('YYYY-MM-DD');
					});
                	formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                    resp.data.Data.data.forEach(item => {
                        let details = [];
                        if(this.fields.length > 0){
                            let length = this.fields.length;
                            let detailItem = {};
                            this.fields.forEach(function (obj, i) {
                                if(obj.name == "pieces"){
                                    item[obj.name] = (item[obj.name] || "") + "片";
                                }
                                if(i%3 == 0){
                                    detailItem = {};
                                    if(obj.type == "6"){
                                        detailItem.field1 = item[obj.name+"name"] || "";
                                    }else{
                                        detailItem.field1 = item[obj.name] || "";
                                    }
                                    if(i == length -1){
                                        details.push(detailItem);
                                    }
                                }
                                if(i%3 == 1){
                                    if(obj.type == "6"){
                                        detailItem.field2 = item[obj.name+"name"] || "";
                                    }else{
                                        detailItem.field2 = item[obj.name] || "";
                                    }
                                    if(i == length -1){
                                        details.push(detailItem);
                                    }
                                }
                                if(i%3 == 2){
                                    if(obj.type == "6"){
                                        detailItem.field3 = item[obj.name+"name"] || "";
                                    }else{
                                        detailItem.field3 = item[obj.name] || "";
                                    }
                                    details.push(detailItem);
                                }
                            });
                        }else{
                            details.push({
                                "field1": item.radCategoryname,
                                "field2": item.radIdname,
                                "field3": item.pieces + "片"
                            });
                            details.push({
                                "field1": item.centerCategoryname,
                                "field2": item.centerSpacing,
                                "field3": item.calibername
                            });
                            details.push({
                                "field1": item.colorname,
                                "field2": item.waterFlowname,
                                "field3": item.isSpecials || ""
                            });
                        }
                        item.details = details;
                    });
                    debugger;
					this.loading = false;
					this.refreshing = false;
					this.list = [...this.list, ...resp.data.Data.data];
					this.finished = resp.data.Data.total <= this.list.length;
				}
			},
			onRefresh() {
				this.finished = false;
				this.pageIndex = 0;
				this.tab = this.tabList[0];
				this.list = [];
				this.onLoad();
			},
			switchTab(index) {
				window.scrollTo(0, 0);
				this.tab = this.tabList[index];
				this.onSearch();
			},
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			async confirm(){
				if(!this.value){
					return ;
				}
				let resp = await barcodeService.outOfStock(this.value,this.uuid);
	            if (resp.data.Status === "1"){
                	Toast.success('扫码出库成功');
					this.value = '';
					this.$refs.barcodeInput.focus();
                	this.onSearch();
					this.getScanningOutput();
	            } else {
					/*if(this.fields.length === 0){
						top.location.href = "/audio/alert";
					}*/

                	Toast.fail(resp.data.Message);
					this.value = '';
	            }
			}
		}
	}
</script>

<style scoped>
	.psiDetailCont{
		width:100%;
		margin:0 auto;
		margin-top:120px;
	}
	.spanBox {
		margin:0 20px;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
</style>
